
import { JsonConvert } from 'json2typescript';
import { encode, trim } from 'url-safe-base64';
import qs from 'qs';
/**
 * base64エンコード後にURLセーフにする置換とbase64エンコードを行う
 */
const base64AndUrlEncode = (param: string): string => encodeURI(trim(encode(window.btoa(param))));

const uriEncode = (param: string): string => encodeURI(param.trim());

const paramsUrlEncode = <T>(param: T): string => qs.stringify(param);

/**
 * リポジトリクラスで利用する共通処理定義
 */
export default class RepositoryBase {
  constructor() {
    this.convert = new JsonConvert();
  }

  public convert: JsonConvert;

  public base64AndUrlEncode = base64AndUrlEncode;

  public uriEncode = uriEncode;

  public paramsUrlEncode = paramsUrlEncode;
}
